import { Reducer as Reducer_ } from 'redux';
import {
  IDesignTemplateSettingsActionType as IDesignTemplateSettingsActionType_,
  IFinancialInstitutionDisclaimersAndFinePrintActionType as IFinancialInstitutionDisclaimersAndFinePrintActionType_,
  IBrowserTabTitleActionType as IBrowserTabTitleActionType_
} from '../actions/setting-actions';
import * as types from '../actions/actionTypes/settings';
import DocumentPortalSettings_ from '../../data/models/DocumentPortalSettings';
import ResponseBase_ from '../../data/models/ResponseBase';

const defaultDocumentPortalSettings: DocumentPortalSettings_ = {
  brandName: '',
  customerPortalTabTitle: '',
  financialInstitutionDisclaimersAndFinePrint: '',
  financialInstitutionMarketingURL: '',
  financialInstitutionMarketingTabletViewURL: '',
  financialInstitutionMarketingMobileViewURL: '',
  headerLeftLogoUrl: '',
  headerLeftTextBottom: '',
  headerLeftTextMiddle: '',
  headerLeftTextTop: '',
  headerRightLogoUrl: '',
  footerLeftImageUrl: '',
  footerMiddleImageUrl: '',
  footerRightImageUrl: '',
  footerTopText: '',
  footerBottomText: '',
  id: null,
  instanceId: '',
  isQDEnabled: false,
  isLeftSideImageSelected: null,
  isRightSideImageSelected: null,
  faviconUrl: '',
};

/* eslint-disable max-len */
export const settingsDesignSystemReducer: Reducer_<ResponseBase_<DocumentPortalSettings_>, IDesignTemplateSettingsActionType_> = (state = { errorCode: 0, message: '', result: defaultDocumentPortalSettings, }, { type, payload, }) => {
  switch (type) {
    case types.GET_DESIGN_TEMPLATE_SETTINGS_FAIL:
    case types.GET_DESIGN_TEMPLATE_SETTINGS_SUCCESS:
      return payload;
    default:
      return state;
  }
};

export const settingsDisclaimersReducer: Reducer_<string, IFinancialInstitutionDisclaimersAndFinePrintActionType_> = (state = '', { type, payload, }) => {
  switch (type) {
    case types.GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_FAIL:
    case types.GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_SUCCESS:
      return payload;
    default:
      return state;
  }
};

export const settingsBrowserTitleReducer: Reducer_<ResponseBase_<string>, IBrowserTabTitleActionType_> = (state = { errorCode: 0, message: '', result: '', }, { type, payload, }) => {
  switch (type) {
    case types.GET_BROWSER_TAB_TITLE_FAIL:
    case types.GET_BROWSER_TAB_TITLE_SUCCESS:
      return payload;
    default:
      return state;
  }
};
